/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { Section14ClientRenewalModel } from './Section14ClientRenewalModel';
import {
    Section14ClientRenewalModelFromJSON,
    Section14ClientRenewalModelFromJSONTyped,
    Section14ClientRenewalModelToJSON,
} from './Section14ClientRenewalModel';

/**
 * 
 * @export
 * @interface ResultOfListOfSection14ClientRenewalModel
 */
export interface ResultOfListOfSection14ClientRenewalModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfListOfSection14ClientRenewalModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfSection14ClientRenewalModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfSection14ClientRenewalModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfSection14ClientRenewalModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfSection14ClientRenewalModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfListOfSection14ClientRenewalModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfListOfSection14ClientRenewalModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<Section14ClientRenewalModel>}
     * @memberof ResultOfListOfSection14ClientRenewalModel
     */
    data?: Array<Section14ClientRenewalModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfSection14ClientRenewalModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfSection14ClientRenewalModel interface.
 */
export function instanceOfResultOfListOfSection14ClientRenewalModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfSection14ClientRenewalModelFromJSON(json: any): ResultOfListOfSection14ClientRenewalModel {
    return ResultOfListOfSection14ClientRenewalModelFromJSONTyped(json, false);
}

export function ResultOfListOfSection14ClientRenewalModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfSection14ClientRenewalModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(Section14ClientRenewalModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfSection14ClientRenewalModelToJSON(value?: ResultOfListOfSection14ClientRenewalModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(Section14ClientRenewalModelToJSON)),
        'Count': value.count,
    };
}

